<template>
    <!-- 头部整体盒子 -->
    <div id="header" class="container-fuild">
        <!-- 头部顶部 -->
        <div class="header-top container-fuild hidden-xs">
            <div class="container">
                <div class="server pull-left">
                    <span class="glyphicon glyphicon-earphone"></span>135-8744-3369
                    <span class="glyphicon glyphicon-envelope"></span><a href="mailto:langetechco@163.com" style="    color: white;font-size: 12px;font-weight: bold;text-decoration: none;">langetechco@163.com</a>
                    <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
                </div>
                <div class="shejiao pull-right" style="letter-spacing: 4px;">
                    专注美好未来......
                </div>
            </div>
        </div>
        <!-- 电脑导航 -->
        <div class="header-nav container hidden-xs">
            <!-- 导航logo -->
            <div class="header-nav-logo">
                <a href="/"><img src="@/assets/img/LOGO.png"></a>
            </div>
            <!-- 导航内容 -->
            <ul class="header-nav-wrapper">
                <li v-for="(item,index) in navList" :key="index" :class="item.active?'active':''" @click="navClick(index)">
                    <router-link :to="item.path">
                        {{item.name}}
                        <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
                        <i class="underline"></i>
                    </router-link>
                    <dl v-if="item.children.length>0">
                        <div class="box" v-for="(i,n) in item.children" :key="n" style="background: rgba(0, 0, 0, 0.6);border-bottom: 1px solid #666666;">
                            <router-link :to="i.path" style="text-decoration: none;color: #fff;">
                                <dt style="width: 100%;padding: 10px;margin: 0 auto;text-align: center;">
                                    {{i.name}}
                                </dt>
                            </router-link>

                        </div>
                        <!-- <dt v-for="(i,n) in item.children"
                :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt> -->
                    </dl>
                </li>
            </ul>
        </div>

        <!-- 手机导航 -->
        <div class="header-nav-m container-fuild visible-xs">

            <!-- 导航栏 -->
            <div class="header-nav-m-menu text-center">
                <div class="header-nav-m-menu-wrapper" data-toggle="collapse" style="left:20px">
                    <span class="glyphicon glyphicon-phone-alt" @click="jumpContactUs"></span>
                </div>
                <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu">
                    <span :class="menuClass"></span>
                </div>
                <!-- 导航内容 -->
                <ul id="menu" class="header-nav-m-wrapper collapse">
                    <li v-for="(item,index) in navList" :key="index" :class="index==navIndex?'active':''" @click="navClick(index)" data-toggle="collapse" data-target="#menu">
                        <router-link :to="item.path">
                            {{item.name}}
                            <i class="underline"></i>
                        </router-link>
                    </li>
                </ul>
            </div>

        </div>
        <div class="header-nav-m-logo">
            <a href="/"> <img class="center-block" src="@/assets/img/LOGO.png" alt="logo" style="width:32%;"></a>

        </div>
    </div>
</template>
<script>
export default {
    name: 'Header',
    data() {
        return {
            navIndex: sessionStorage.getItem('naxIndex')
                ? sessionStorage.getItem('naxIndex')
                : 0,
            menuName: '首页',
            menuClass: 'glyphicon glyphicon-th-large',
            navList: [
                {
                    name: '首页',
                    path: '/',
                    active: true,
                    children: [],
                },
                {
                    name: '注塑机',
                    path: '/service',
                    children: [],
                    active: false,
                },
                {
                    name: '辅机设备',
                    path: '/equipment',
                    active: false,
                    children: [
                        {
                            name: '机械手',
                            path: '/equipment/manipulator',
                        },
                        {
                            name: '粉碎机',
                            path: '/equipment/grinder',
                        },
                       
                        {
                            name: '冷水机',
                            path: '/equipment/coolingMachine',
                        },
                      
                    ],
                },
                {
                    name: '发展历程',
                    path: '/developmentHistory',
                    active: false,
                    children: [],
                },
                {
                    name: '公司介绍',
                    path: '/companyintroduction',
                    active: false,
                    children: [],
                },
                {
                    name: '联系我们',
                    path: '/contactus',
                    active: false,
                    children: [],
                },
            ],
        }
    },
    watch: {
        $route(to, from) {
            var arr = [
                '/contactus',
                '/companyintroduction',
                '/developmentHistory',
                '/equipment',
                '/service',
                '/',
            ]
            if (arr.includes(to.path)) {
                this.navList.forEach(function (item) {
                    if (item.path == to.path) {
                        item.active = true
                    } else {
                        item.active = false
                    }
                })
            }
        },
    },
    methods: {
        navClick(index) {
            this.navList.forEach(function (item) {
                item.active = false
            })
            this.navList[index].active = true
        },
        jumpContactUs() {
            this.$router.push({
                path: 'contactus',
                params: {
                    isRefresh: true,
                },
            })
        },
    },
}
</script>
<style lang="less" scoped>
/deep/ .box a dt:hover {
    background: #df7e12;
}
.header-nav-m-logo {
    display: none;
}
/* 顶部 */
#header {
    background: #f4f4f4;
    transition: all ease 0.6s;
}
#header .header-top {
    height: 40px;
    color: #fff;
    font-size: 12px;
    line-height: 40px;
    background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
    margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
    height: 110px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
    width: 200px;
    height: 100%;
    float: left;
    position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
    width: 195px;
    height: 190px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
    line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
    line-height: 110px;
    float: right;
    margin: 0;
    max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
    float: left;
    margin: 0 28px;
    position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
    color: #000;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
    display: block;
    position: absolute;
    bottom: -2px;
    left: 50%;
    width: 0;
    height: 2px;
    opacity: 0;
    transition: all 0.6s ease;
    background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 12px;
    transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
    color: #1e73be;
    text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
    opacity: 1;
    width: 100%;
    left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
    transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
    color: #1e73be;
    text-decoration: none;
    border-bottom: 2px solid #1e73be;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
    display: none;
    position: absolute;
    width: 78px;
    top: 80%;
    left: 0;
    z-index: 999999;
    box-shadow: 0 0 3px 1px #ccc;
    background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
    width: 100%;
    padding: 10px;
    border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
    text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
    display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
    cursor: pointer;
    background: #ccc;
}
@media screen and (max-width: 997px) {
    #header .header-nav-m {
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 999;
    }
    .header-nav-m-logo {
        display: block;
        margin-top: 45px;
    }
    #header .header-nav .header-nav-wrapper > li {
        float: left;
        margin: 0 12px;
        position: relative;
    }
    /* 导航栏logo容器 */
    #header .header-nav-m .header-nav-m-logo {
        height: 120px;
        position: relative;
    }
    /* 导航栏logo图片 */
    #header .header-nav-m .header-nav-m-logo img {
        width: 150px;
        height: 150px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
    }
    /* 导航栏  菜单容器 */
    #header .header-nav-m .header-nav-m-menu {
        color: #fff;
        height: 50px;
        font-size: 20px;
        line-height: 50px;
        background: #474747;
        position: relative;
    }
    /* 导航栏 菜单图标 */
    #header .header-nav-m .header-nav-m-menu-wrapper {
        position: absolute;
        top: 50%;
        right: 20px;
        margin-top: -23px;
        width: 50px;
        height: 40px;
        color: #fff;
        z-index: 999999;
        font-size: 16px;
    }
    /* 导航栏 */
    #header .header-nav-m .header-nav-m-wrapper {
        position: absolute;
        top: 50px;
        left: 0;
        width: 100%;
        background: #474747;
        z-index: 9999999;
    }
    /* 导航栏 每个导航 */
    #header .header-nav-m .header-nav-m-wrapper > li {
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #ccc;
    }
    /* 导航栏 每个导航下面的 a 链接 */
    #header .header-nav-m .header-nav-m-wrapper > li > a {
        color: #fff;
        font-size: 15px;
        font-weight: bold;
        padding: 15px 0;
        position: relative;
    }
    /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
    #header .header-nav .header-nav-wrapper > li > a > span {
        font-size: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue